import { render, staticRenderFns } from "./popGallery.vue?vue&type=template&id=15fccd74&scoped=true&"
import script from "./popGallery.vue?vue&type=script&lang=ts&"
export * from "./popGallery.vue?vue&type=script&lang=ts&"
import style0 from "./popGallery.scss?vue&type=style&index=0&id=15fccd74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fccd74",
  null
  
)

export default component.exports